import dynamic from "next/dynamic";
import { FC, ReactNode } from "react";

interface PortalLayoutProps {
  children: ReactNode;
}

const PortalNavBarNoSSR = dynamic(
  () => import("components/_Pages/Portal/NavBar/PortalNavBar"),
  {
    ssr: false,
    // Reserva la altura del navbar para evitar layout shift al hidratar
    loading: () => <div className="h-[65px] w-full" />,
  }
);

const PortalLayout: FC<PortalLayoutProps> = ({ children }) => (
  <div className="min-h-screen min-w-full">
    {/* El navbar es sticky (en flujo): el contenido ya no necesita padding compensatorio */}
    <PortalNavBarNoSSR />
    <div style={{ minHeight: "calc(100vh - 100px)" }}>
      <div className="animate__animated" id="layoutMainContent">
        <div className="h-full min-h-full">{children}</div>
      </div>
    </div>
  </div>
);

export default PortalLayout;
